import { BaseRemittanceContributionSummary } from './base-remittance-contribution-summary';

export class ScheduledRemittanceContributionSummary extends BaseRemittanceContributionSummary {
  public scheduledRemittanceId!: number;
}
